export const COUNTRIES = [
  {
    label: 'United States of America',
    shortLabel: 'USA',
    value: 'USA',
  },
  {
    label: 'United States Virgin Islands',
    shortLabel: 'Virgin Islands',
    value: 'VIR',
  },
  { label: 'Afghanistan', value: 'AFG' },
  {
    label: 'Åland Islands',
    shortLabel: 'Aland Islands',
    value: 'ALA',
  },
  { label: 'Albania', value: 'ALB' },
  { label: 'Algeria', value: 'DZA' },
  { label: 'American Samoa', value: 'ASM' },
  { label: 'Andorra', value: 'AND' },
  { label: 'Angola', value: 'AGO' },
  { label: 'Anguilla', value: 'AIA' },
  { label: 'Antigua and Barbuda', value: 'ATG' },
  { label: 'Argentina', value: 'ARG' },
  { label: 'Armenia', value: 'ARM' },
  { label: 'Aruba', value: 'ABW' },
  { label: 'Australia', value: 'AUS' },
  { label: 'Austria', value: 'AUT' },
  { label: 'Azerbaijan', value: 'AZE' },
  { label: 'Bahamas', value: 'BHS' },
  { label: 'Bahrain', value: 'BHR' },
  { label: 'Bangladesh', value: 'BGD' },
  { label: 'Barbados', value: 'BRB' },
  { label: 'Belarus', value: 'BLR' },
  { label: 'Belgium', value: 'BEL' },
  { label: 'Belize', value: 'BLZ' },
  { label: 'Benin', value: 'BEN' },
  { label: 'Bermuda', value: 'BMU' },
  { label: 'Bhutan', value: 'BTN' },
  {
    label: 'Bolivia (Plurinational State of)',
    shortLabel: 'Bolivia',
    value: 'BOL',
  },
  {
    label: 'Bonaire, Saint Eustatius and Saba',
    shortLabel: 'Bonaire',
    value: 'BES',
  },
  { label: 'Bosnia and Herzegovina', value: 'BIH' },
  { label: 'Botswana', value: 'BWA' },
  { label: 'Brazil', value: 'BRA' },
  { label: 'British Virgin Islands', value: 'VGB' },
  { label: 'Brunei Darussalam', value: 'BRN' },
  { label: 'Bulgaria', value: 'BGR' },
  { label: 'Burkina Faso', value: 'BFA' },
  { label: 'Burundi', value: 'BDI' },
  { label: 'Cape Verde', value: 'CPV' },
  { label: 'Cambodia', value: 'KHM' },
  { label: 'Cameroon', value: 'CMR' },
  { label: 'Canada', value: 'CAN' },
  { label: 'Cayman Islands', value: 'CYM' },
  { label: 'Central African Republic', value: 'CAF' },
  { label: 'Chad', value: 'TCD' },
  { label: 'Chile', value: 'CHL' },
  { label: 'China', value: 'CHN' },
  {
    label: 'China, Hong Kong Special Administrative Region',
    shortLabel: 'China',
    value: 'HKG',
  },
  {
    label: 'China, Macao Special Administrative Region',
    shortLabel: 'Macao',
    value: 'MAC',
  },
  { label: 'Colombia', value: 'COL' },
  { label: 'Comoros', value: 'COM' },
  { label: 'Congo', value: 'COG' },
  { label: 'Cook Islands', value: 'COK' },
  { label: 'Costa Rica', value: 'CRI' },
  { label: "Côte d'Ivoire", value: 'CIV' },
  { label: 'Croatia', value: 'HRV' },
  { label: 'Cuba', value: 'CUB' },
  { label: 'Curaçao', value: 'CUW' },
  { label: 'Cyprus', value: 'CYP' },
  { label: 'Czech Republic', value: 'CZE' },
  {
    label: "Democratic People's Republic of Korea",
    shortLabel: 'North Korea',
    value: 'PRK',
  },
  {
    label: 'Democratic Republic of the Congo',
    shortLabel: 'Congo',
    value: 'COD',
  },
  { label: 'Denmark', value: 'DNK' },
  { label: 'Djibouti', value: 'DJI' },
  { label: 'Dominica', value: 'DMA' },
  { label: 'Dominican Republic', value: 'DOM' },
  { label: 'Ecuador', value: 'ECU' },
  { label: 'Egypt', value: 'EGY' },
  { label: 'El Salvador', value: 'SLV' },
  { label: 'Equatorial Guinea', value: 'GNQ' },
  { label: 'Eritrea', value: 'ERI' },
  { label: 'Estonia', value: 'EST' },
  { label: 'Ethiopia', value: 'ETH' },
  { label: 'Faeroe Islands', value: 'FRO' },
  {
    label: 'Falkland Islands (Malvinas)',
    shortLabel: 'Falkland Islands',
    value: 'FLK',
  },
  { label: 'Fiji', value: 'FJI' },
  { label: 'Finland', value: 'FIN' },
  { label: 'France', value: 'FRA' },
  { label: 'French Guiana', value: 'GUF' },
  { label: 'French Polynesia', value: 'PYF' },
  { label: 'Gabon', value: 'GAB' },
  { label: 'Gambia', value: 'GMB' },
  { label: 'Georgia', value: 'GEO' },
  { label: 'Germany', value: 'DEU' },
  { label: 'Ghana', value: 'GHA' },
  { label: 'Gibraltar', value: 'GIB' },
  { label: 'Greece', value: 'GRC' },
  { label: 'Greenland', value: 'GRL' },
  { label: 'Grenada', value: 'GRD' },
  { label: 'Guadeloupe', value: 'GLP' },
  { label: 'Guam', value: 'GUM' },
  { label: 'Guatemala', value: 'GTM' },
  { label: 'Guernsey', value: 'GGY' },
  { label: 'Guinea', value: 'GIN' },
  { label: 'Guinea-Bissau', value: 'GNB' },
  { label: 'Guyana', value: 'GUY' },
  { label: 'Haiti', value: 'HTI' },
  { label: 'Holy See', value: 'VAT' },
  { label: 'Honduras', value: 'HND' },
  { label: 'Hungary', value: 'HUN' },
  { label: 'Iceland', value: 'ISL' },
  { label: 'India', value: 'IND' },
  { label: 'Indonesia', value: 'IDN' },
  {
    label: 'Iran (Islamic Republic of)',
    shortLabel: 'Iran',
    value: 'IRN',
  },
  { label: 'Iraq', value: 'IRQ' },
  { label: 'Ireland', value: 'IRL' },
  { label: 'Isle of Man', value: 'IMN' },
  { label: 'Israel', value: 'ISR' },
  { label: 'Italy', value: 'ITA' },
  { label: 'Jamaica', value: 'JAM' },
  { label: 'Japan', value: 'JPN' },
  { label: 'Jersey', value: 'JEY' },
  { label: 'Jordan', value: 'JOR' },
  { label: 'Kazakhstan', value: 'KAZ' },
  { label: 'Kenya', value: 'KEN' },
  { label: 'Kiribati', value: 'KIR' },
  { label: 'Kuwait', value: 'KWT' },
  { label: 'Kyrgyzstan', value: 'KGZ' },
  {
    label: "Lao People's Democratic Republic",
    shortLabel: 'Lao',
    value: 'LAO',
  },
  { label: 'Latvia', value: 'LVA' },
  { label: 'Lebanon', value: 'LBN' },
  { label: 'Lesotho', value: 'LSO' },
  { label: 'Liberia', value: 'LBR' },
  { label: 'Libya', value: 'LBY' },
  { label: 'Liechtenstein', value: 'LIE' },
  { label: 'Lithuania', value: 'LTU' },
  { label: 'Luxembourg', value: 'LUX' },
  { label: 'Madagascar', value: 'MDG' },
  { label: 'Malawi', value: 'MWI' },
  { label: 'Malaysia', value: 'MYS' },
  { label: 'Maldives', value: 'MDV' },
  { label: 'Mali', value: 'MLI' },
  { label: 'Malta', value: 'MLT' },
  { label: 'Marshall Islands', value: 'MHL' },
  { label: 'Martinique', value: 'MTQ' },
  { label: 'Mauritania', value: 'MRT' },
  { label: 'Mauritius', value: 'MUS' },
  { label: 'Mayotte', value: 'MYT' },
  { label: 'Mexico', value: 'MEX' },
  {
    label: 'Micronesia (Federated States of)',
    shortLabel: 'Micronesia',
    value: 'FSM',
  },
  { label: 'Monaco', value: 'MCO' },
  { label: 'Mongolia', value: 'MNG' },
  { label: 'Montenegro', value: 'MNE' },
  { label: 'Montserrat', value: 'MSR' },
  { label: 'Morocco', value: 'MAR' },
  { label: 'Mozambique', value: 'MOZ' },
  { label: 'Myanmar', value: 'MMR' },
  { label: 'Namibia', value: 'NAM' },
  { label: 'Nauru', value: 'NRU' },
  { label: 'Nepal', value: 'NPL' },
  { label: 'Netherlands', value: 'NLD' },
  { label: 'New Caledonia', value: 'NCL' },
  { label: 'New Zealand', value: 'NZL' },
  { label: 'Nicaragua', value: 'NIC' },
  { label: 'Niger', value: 'NER' },
  { label: 'Nigeria', value: 'NGA' },
  { label: 'Niue', value: 'NIU' },
  { label: 'Norfolk Island', value: 'NFK' },
  {
    label: 'Northern Mariana Islands',
    shortLabel: 'Mariana Islands',
    value: 'MNP',
  },
  { label: 'Norway', value: 'NOR' },
  { label: 'Oman', value: 'OMN' },
  { label: 'Pakistan', value: 'PAK' },
  { label: 'Palau', value: 'PLW' },
  { label: 'Panama', value: 'PAN' },
  { label: 'Papua New Guinea', value: 'PNG' },
  { label: 'Paraguay', value: 'PRY' },
  { label: 'Peru', value: 'PER' },
  { label: 'Philippines', value: 'PHL' },
  { label: 'Pitcairn', value: 'PCN' },
  { label: 'Poland', value: 'POL' },
  { label: 'Portugal', value: 'PRT' },
  { label: 'Puerto Rico', value: 'PRI' },
  { label: 'Qatar', value: 'QAT' },
  { label: 'Republic of Korea', value: 'KOR' },
  {
    label: 'Republic of Moldova',
    shortLabel: 'Moldova',
    value: 'MDA',
  },
  { label: 'Réunion', value: 'REU' },
  { label: 'Romania', value: 'ROU' },
  { label: 'Russian Federation', value: 'RUS' },
  { label: 'Rwanda', value: 'RWA' },
  { label: 'Saint-Barthélemy', value: 'BLM' },
  { label: 'Saint Helena', value: 'SHN' },
  { label: 'Saint Kitts and Nevis', value: 'KNA' },
  { label: 'Saint Lucia', value: 'LCA' },
  {
    label: 'Saint-Martin (French part)',
    shortLabel: 'Saint-Martin',
    value: 'MAF',
  },
  { label: 'Saint Pierre and Miquelon', value: 'SPM' },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'VCT',
  },
  { label: 'Samoa', value: 'WSM' },
  { label: 'San Marino', value: 'SMR' },
  { label: 'Sao Tome and Principe', value: 'STP' },
  { label: 'Saudi Arabia', value: 'SAU' },
  { label: 'Senegal', value: 'SEN' },
  { label: 'Serbia', value: 'SRB' },
  { label: 'Seychelles', value: 'SYC' },
  { label: 'Sierra Leone', value: 'SLE' },
  { label: 'Singapore', value: 'SGP' },
  {
    label: 'Sint Maarten (Dutch part)',
    shortLabel: 'Sint Maarten',
    value: 'SXM',
  },
  { label: 'Slovakia', value: 'SVK' },
  { label: 'Slovenia', value: 'SVN' },
  { label: 'Solomon Islands', value: 'SLB' },
  { label: 'Somalia', value: 'SOM' },
  { label: 'South Africa', value: 'ZAF' },
  { label: 'South Sudan', value: 'SSD' },
  { label: 'Spain', value: 'ESP' },
  { label: 'Sri Lanka', value: 'LKA' },
  {
    label: 'State of Palestine',
    shortLabel: 'Palestine',
    value: 'PSE',
  },
  { label: 'Sudan', value: 'SDN' },
  { label: 'Suriname', value: 'SUR' },
  {
    label: 'Svalbard and Jan Mayen Islands',
    shortLabel: 'Svalbard',
    value: 'SJM',
  },
  { label: 'Swaziland', value: 'SWZ' },
  { label: 'Sweden', value: 'SWE' },
  { label: 'Switzerland', value: 'CHE' },
  { label: 'Syrian Arab Republic', value: 'SYR' },
  { label: 'Taiwan', value: 'TWAN' },
  { label: 'Tajikistan', value: 'TJK' },
  { label: 'Thailand', value: 'THA' },
  {
    label: 'The former Yugoslav Republic of Macedonia',
    shortLabel: 'Macedonia',
    value: 'MKD',
  },
  { label: 'Timor-Leste', value: 'TLS' },
  { label: 'Togo', value: 'TGO' },
  { label: 'Tokelau', value: 'TKL' },
  { label: 'Tonga', value: 'TON' },
  { label: 'Trinidad and Tobago', value: 'TTO' },
  { label: 'Tunisia', value: 'TUN' },
  { label: 'Turkey', value: 'TUR' },
  { label: 'Turkmenistan', value: 'TKM' },
  {
    label: 'Turks and Caicos Islands',
    shortLabel: 'Turks & Caicos',
    value: 'TCA',
  },
  { label: 'Tuvalu', value: 'TUV' },
  { label: 'Uganda', value: 'UGA' },
  { label: 'Ukraine', value: 'UKR' },
  {
    label: 'United Arab Emirates',
    shortLabel: 'UAE',
    value: 'ARE',
  },
  {
    label: 'United Kingdom of Great Britain and Northern Ireland',
    shortLabel: 'United Kingdom',
    value: 'GBR',
  },
  {
    label: 'United Republic of Tanzania',
    shortLabel: 'United Republic of Tanzania',
    value: 'TZA',
  },
  { label: 'Uruguay', value: 'URY' },
  { label: 'Uzbekistan', value: 'UZB' },
  { label: 'Vanuatu', value: 'VUT' },
  {
    label: 'Venezuela (Bolivarian Republic of)',
    shortLabel: 'Venezuela',
    value: 'VEN',
  },
  { label: 'Vietnam', value: 'VNM' },
  {
    label: 'Wallis and Futuna Islands',
    shortLabel: 'Wallis',
    value: 'WLF',
  },
  { label: 'Western Sahara', value: 'ESH' },
  { label: 'Yemen', value: 'YEM' },
  { label: 'Zambia', value: 'ZMB' },
  { label: 'Zimbabwe', value: 'ZWE' },
];

export const US_STATES = [
  { label: '--', value: '', field: '' },
  { label: 'AL', value: 'AL', field: '' },
  { label: 'AK', value: 'AK', field: '' },
  { label: 'AZ', value: 'AZ', field: '' },
  { label: 'AR', value: 'AR', field: '' },
  { label: 'CA', value: 'CA', field: '' },
  { label: 'CO', value: 'CO', field: '' },
  { label: 'CT', value: 'CT', field: '' },
  { label: 'DE', value: 'DE', field: '' },
  { label: 'DC', value: 'DC', field: '' },
  { label: 'FL', value: 'FL', field: '' },
  { label: 'GA', value: 'GA', field: '' },
  { label: 'HI', value: 'HI', field: '' },
  { label: 'ID', value: 'ID', field: '' },
  { label: 'IL', value: 'IL', field: '' },
  { label: 'IN', value: 'IN', field: '' },
  { label: 'IA', value: 'IA', field: '' },
  { label: 'KS', value: 'KS', field: '' },
  { label: 'KY', value: 'KY', field: '' },
  { label: 'LA', value: 'LA', field: '' },
  { label: 'ME', value: 'ME', field: '' },
  { label: 'MD', value: 'MD', field: '' },
  { label: 'MA', value: 'MA', field: '' },
  { label: 'MI', value: 'MI', field: '' },
  { label: 'MN', value: 'MN', field: '' },
  { label: 'MS', value: 'MS', field: '' },
  { label: 'MO', value: 'MO', field: '' },
  { label: 'MT', value: 'MT', field: '' },
  { label: 'NE', value: 'NE', field: '' },
  { label: 'NV', value: 'NV', field: '' },
  { label: 'NH', value: 'NH', field: '' },
  { label: 'NJ', value: 'NJ', field: '' },
  { label: 'NM', value: 'NM', field: '' },
  { label: 'NY', value: 'NY', field: '' },
  { label: 'NC', value: 'NC', field: '' },
  { label: 'ND', value: 'ND', field: '' },
  { label: 'OH', value: 'OH', field: '' },
  { label: 'OK', value: 'OK', field: '' },
  { label: 'OR', value: 'OR', field: '' },
  { label: 'PA', value: 'PA', field: '' },
  { label: 'RI', value: 'RI', field: '' },
  { label: 'SC', value: 'SC', field: '' },
  { label: 'SD', value: 'SD', field: '' },
  { label: 'TN', value: 'TN', field: '' },
  { label: 'TX', value: 'TX', field: '' },
  { label: 'UT', value: 'UT', field: '' },
  { label: 'VT', value: 'VT', field: '' },
  { label: 'VA', value: 'VA', field: '' },
  { label: 'WA', value: 'WA', field: '' },
  { label: 'WV', value: 'WV', field: '' },
  { label: 'WI', value: 'WI', field: '' },
  { label: 'WY', value: 'WY', field: '' },
];
